import { makeBlock } from '../helpers'
import { IdleBlock } from './Block/IdleBlock'
import { FloatingIdleBlock } from './Block/FloatingBlock'
import moment from 'moment'
import { Time } from '../config'

export class Line {
  constructor () {
    this.head = null
    this.tail = null
  }

  /**
   *
   * @returns {boolean}
   */
  get isEmpty () {
    return this.head === null
  }

  /**
   *
   * @returns {Array}
   */
  get blocks () {
    let blocks = []
    let current = this.head
    while (current) {
      blocks.push(current)
      current = current._next
    }
    return blocks
  }

  /**
   *
   * @returns {Array}
   */
  get cells () {
    let counter = {}
    return this.blocks.map((block, i) => {
      let b = `${block.id}`
      if (!(b in counter)) {
        counter[b] = 0
      }
      counter[b]++
      return block.getCells(i, counter[b])
    }).reduce((a, b) => a.concat(b), [])
  }

  /**
   *
   * @returns {Number}
   */
  get end () {
    if (!this.tail) {
      return 0
    }

    let current = this.tail
    while (current._prev) {
      if (current.type === 'floating') {
        break
      }
      current = current._prev
    }

    if (current.type !== 'floating') {
      return +moment().format(Time.unix)
    }

    return current.end
  }

  /**
   *
   * @param id
   */
  getBlock (id) {
    let block = this.head
    try {
      for (let i = 0; i < id; ++i) {
        block = block._next
      }
      return block
    } catch (e) {
      return null
    }
  }

  /**
   *
   * @param block
   */
  push (block) {
    if (!Number.isInteger(block.start) || block.start <= 0 || !Number.isInteger(block.time) || block.time <= 0) {
      throw new Error('Insert time is not a number!')
    }

    const week = 7 * 24 * 3600 * 1000

    if (this.isEmpty) {
      if (block.type !== 'fixed') {
        this.head = new IdleBlock(block.start - week, week)
        this.head.linkNext(block)
        this.tail = block
      } else {
        this.head = this.tail = block
      }
    } else {
      let active = this.active(block.start)
      if (!active) {
        block.linkPrev(new IdleBlock(block.start - week, week))
        this.head.prepend(block)
      } else {
        active.append(block)
      }
    }
    this.normalize()
  }

  /**
   *
   * @param time
   * @returns {{}|null}
   */
  active (time) {
    let current = this.tail

    if (!current || current.end < time) {
      return current
    }

    while (current) {
      if (current.start <= time && current.end >= time) {
        return current
      }
      current = current._prev
    }
    return null
  }

  /**
   *
   * @param time
   * @returns {boolean}
   */
  isActive (time) {
    if (time > this.end) {
      return false
    }
    const active = this.active(time)
    return !(active === null || active.type === 'fixed' || active.kind === 'idle')
  }

  normalize () {
    if (this.head) {
      while (this.head._prev) {
        this.head = this.head._prev
      }
      this.head.bubbleNext()
      let current = this.head
      while (current._next) {
        if (current.end !== current._next.start && !current._next.isOutage) {
          current.linkNext(new FloatingIdleBlock(current.end, current._next.start - current.end, current, current._next))
        }
        current = current._next
      }
      this.tail = current
    }

    if (!this.head) {
      this.tail = null
    }
  }

  remove (id, cb) {
    this.getBlock(id).remove()

    if (id === 0 && this.head) {
      this.head = this.head._next
    }

    this.normalize()
    cb()
  }

  clear () {
    this.head = null
    this.tail = null
  }

  /**
   * @param id
   * @param end
   * @param cb
   */
  changeEnd (id, end, cb = () => {}) {
    this.getBlock(id).changeEnd(end)
    this.normalize()
    cb()
  }

  /**
   *
   * @param id
   * @param start
   * @param cb
   */
  changeStart (id, start, cb = () => {}) {
    this.getBlock(id).changeStart(start)
    this.normalize()
    cb()
  }

  /**
   *
   * @param time
   * @param die
   * @returns {{startup: boolean, shutdown: boolean}}
   */
  condition (time, die) {
    const block = this.active(time - 1)
    let startup = false
    let shutdown = false

    if (!block) {
      startup = true
      shutdown = true
    } else {
      // @todo
    }

    return { startup, shutdown }
  }

  /**
   *
   * @param head
   * @returns {Line}
   */
  static assign (head) {
    if (!head) {
      return new Line()
    }

    let line = new Line()
    line.head = makeBlock(head)
    line.tail = line.head

    let current = head
    while (current._next) {
      let block = makeBlock(current._next)
      line.tail.linkNext(block)
      line.tail = block
      current = current._next
    }

    return line
  }
}
